import { render, staticRenderFns } from "./radio-control.vue?vue&type=template&id=108580ca&"
import script from "./radio-control.vue?vue&type=script&lang=js&"
export * from "./radio-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('108580ca', component.options)
    } else {
      api.reload('108580ca', component.options)
    }
    module.hot.accept("./radio-control.vue?vue&type=template&id=108580ca&", function () {
      api.rerender('108580ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/ui/radio-control.vue"
export default component.exports